var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h3",
        [
          _c("plain-text-control", {
            attrs: { title: "AidTargetYearlyReport.GeneralExpenses.Title" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("general-expenses-table", {
        attrs: {
          id: "general-expenses-table",
          rows: _vm.expenses,
          titleKey: "AidTargetYearlyReport.GeneralExpenses.Breakdown.Title"
        }
      }),
      _vm._v(" "),
      _c("line-control", {
        attrs: {
          id: "general-expenses",
          titleKey: "AidTargetYearlyReport.GeneralExpenses.TotalTitle",
          tableKey: "AidTargetYearlyReport.ColumnHeaders.ExpenseEntry",
          showColumnTotals: true
        },
        model: {
          value: _vm.wrapper,
          callback: function($$v) {
            _vm.wrapper = $$v
          },
          expression: "wrapper"
        }
      }),
      _vm._v(" "),
      _vm.totalGeneralExpenses
        ? _c(
            "div",
            { staticClass: "row form-group text-area-row" },
            [
              _c("plain-text-control", {
                staticClass:
                  "col-xs-12 col-sm-5 col-form-label reduced-icon-line-height",
                attrs: {
                  title:
                    "AidTargetYearlyReport.GeneralExpenses.AidTargetedPercentage"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-sm-7 col-form-label" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.aidTargetedPercentage ||
                        _vm.aidTargetedPercentage == 0
                        ? _vm.aidTargetedPercentage + "%"
                        : ""
                    )
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }